document.addEventListener("DOMContentLoaded", () => {
  const containers = document.querySelectorAll(".size-chart-container");

  containers.forEach(container => {
    const chips = container.querySelectorAll(".unit-chip");

    chips.forEach(chip => {
      chip.addEventListener("click", () => {
        const unit = chip.dataset.unit;

        // Toggle active state
        chips.forEach(c => {
          c.classList.remove("active");
          c.setAttribute("aria-pressed", "false");
        });
        chip.classList.add("active");
        chip.setAttribute("aria-pressed", "true");

        // Hide/show tables in this container
        const inchTables = container.querySelectorAll("table[id*='inch']");
        const cmTables   = container.querySelectorAll("table[id*='cm']");

        if (unit === "inch") {
          inchTables.forEach(t => t.style.display = "table");
          cmTables.forEach(t => t.style.display = "none");
        } else {
          cmTables.forEach(t => t.style.display = "table");
          inchTables.forEach(t => t.style.display = "none");
        }
      });
    });
  });
});
